import React from 'react';
import PropTypes from 'prop-types';
import FluidImage from 'components/fluid-image';

const Teaser = ({ image, initialImageWidth = 800, title, body }) => {
  return (
    <div className="teaser">
      <div className="teaser__image">
        {image && (
          <FluidImage
            {...image}
            initialSize={image.initialSize || initialImageWidth}
          />
        )}
      </div>
      {title && <h4 className="teaser__title">{title}</h4>}
      {body && <p className="teaser__body">{body}</p>}
    </div>
  );
};

Teaser.propTypesMeta = {
  initialImageWidth: 'exclude'
};

Teaser.propTypes = {
  image: PropTypes.exact(FluidImage.propTypes),
  initialImageWidth: PropTypes.number,
  title: PropTypes.string,
  body: PropTypes.string
};

export default Teaser;
